<template>
  <segment>
    <h3 class="ui dividing header">
      <i class="comments icon"/>
      <div class="content">
        {{ $t('patientInfo.patientFeedback' ) }}
        <div class="sub header">
          {{ $t('patientInfo.feedbackSub') }}
        </div>
      </div>
    </h3>

    <message :message="message"/>

    <patient-feedback
      :is-loading="isLoading"
      :old-coach-message="patient.data.coachMessage"
      @update-coach-message="updateCoachMessage"/>

    <patient-monitoring :patient="patient"/>
  </segment>
</template>

<script>
import { Patient } from '../../structs/structs'
import PatientFeedback from './PatientFeedback'
import PatientMonitoring from './PatientMonitoring'
import Segment from '../utility/Segment'

export default {
  name: 'PatientFeedbackAndMonitoring',
  components: {
    Segment,
    PatientFeedback,
    PatientMonitoring
  },
  props: {
    patient: {
      type: Patient,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      message: {
        text: '',
        class: ''
      }
    }
  },
  methods: {
    updateCoachMessage (newCoachMessage) {
      this.isLoading = true
      this.message = {
        text: '',
        class: ''
      }

      newCoachMessage.lastModifiedTime = Date.now()

      let newPatient = {
        userId: this.patient.userId,
        externalId: this.patient.externalId,
        consent: this.patient.consent,
        name: this.patient.name,
        data: Object.assign({}, this.patient.data)
      }

      newPatient.data.coachMessage = newCoachMessage

      let requestUrl = 'programs/' + process.env.VUE_APP_PROGRAM_ID + '/programUsers/' + newPatient.userId

      this.$axios.put(
        requestUrl,
        newPatient,
        this.requestConfig
      ).then(
        () => {
          this.message = {
            text: this.$t('patientInfo.updateSuccess'),
            class: 'success'
          }
          this.$emit('refresh')
        },
        error => {
          this.$rollbar.error(error)
          this.message = {
            text: this.$t('error.unexpected'),
            class: 'error'
          }
        }
      ).then(
        () => {
          this.isLoading = false
        }
      )
    }
  }
}
</script>
